// Routes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import App from "./App";
import CandidatePage from "./CandidatePage"; // <-- make sure this file exists & default-exports the component
import AlgoMindAcademyPlayground from "./AlgoMindAcademyPlayground";

export default function AppRoutes() {
  return (
    <Routes>
      {/* top-level root */}
      <Route path="/" element={<App />} />

      {/* Candidate page must come before the :tab catch-alls so it's not swallowed */}
      <Route path="/candidate/:token" element={<CandidatePage />} />

      {/* explicit route with both tab + roleId — must come BEFORE catch-alls */}
      <Route path="/:tab/:roleId" element={<App />} />

      {/* optional: handle tab with any trailing segments (catch-all) */}
      <Route path="/:tab/*" element={<App />} />

      {/* fallback for single tab (if needed) */}
      <Route path="/:tab" element={<App />} />

      {/* keep direct apply-form route if you want /apply-form/:roleId to mount App directly */}
      <Route path="/apply-form/:roleId" element={<App />} />
      
      <Route path="/playground" element={<AlgoMindAcademyPlayground />} />
      
    </Routes>
  );
}
